<template>
    <div >
      <h2 v-if="title" class="title"><translate>{{title}}</translate></h2>
        <hr class="titleLine">
      <div class="row container-crud q-px-sm">
        <div class="fit">
          <q-card class="q-px-sm " style="box-shadow: none !important;">
            <q-card-section class="data-card-main grid-layout">

              <div
                v-for="(obj, index) in computedInputsTypeElements"
                :key="index"
                :class="getClassesByTheElement(obj)"
              >
                <label>{{ obj.label }}:</label>
                {{ formatedValue(model[obj.name], obj) }}
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
const { pageDetail } = JtCrud
  @Component({
    mixins: [pageDetail],
    name: 'crudLayoutDetail',
    components: { pageDetail },
    props: {
      title: String,
      name: String,
      forms: { type: Array, required: true },
      params: Object,
      parent: Object,
      buttonHidden: {
        type: Boolean,
        default: false
      }
    }
  })
class SummaryPageDetail extends Vue {
    formatedValue (value, object) {
      if (object.name === 'value' || object.name === 'fees' ||
      object.name === 'fine' || object.name === 'correction' ||
      object.name === 'correctedValue' || object.name === 'approximateValue' ||
    object.name === 'interestDiscount' || object.name === 'fineDiscount' ||
  object.name === 'correctionDiscount' || object.name === 'totalDiscount' ||
object.name === 'fineAfterDiscount' ||
object.name === 'fine' ||
object.name === 'correctionAfterDiscount' ||
object.name === 'interest' ||
object.name === 'totalValue') {
        return this.$toLocaleStringBr(value)
      }
      return value
    }
  }
export default SummaryPageDetail
</script>
  <style lang="stylus" scoped>
  @import '~quasar-variables';

  .title {
    color: #2C3F50;
    font-weight: 400;
    margin: 0;
    font-size: 1.075rem;
    margin-bottom: 0.75rem;
    max-height: 0.775rem;
    display: flex;
    align-items: center;
    width: 500px;
  }

  .titleLine {
    width: 90%;
    border: none;
    height: 2px;
    background-color: #c7bdbd;
    border-radius: 4px;
    margin-left: 0;
    margin-bottom:0;
    margin-top: 0;
  }

  for num in 1 .. 12 {
    .col-start-{num} {
      grid-column-start: num;
    }
  }

  for num in 1 .. 13 {
    .col-end-{num} {
      grid-column-end: num;
    }
  }

  .grid-layout {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: max-content;
  }

  .data-card-header {
    font-size: 1.3em;
    padding: 10px 17px 0px;
  }

  .data-card-main.q-card__section {
    height: calc(100% - 65px);
    overflow: hidden;
    padding: 15px 0;
  }

  .data-card-main.q-card__section > div {
    padding: 5px 12px;
  }

  .data-card-main.q-card__section > div > label {
    font-weight: bold;
  }

  .row-grey {
    background: $ice;
  }
  </style>
